type Play = {
  fields: {
    name: string
    selected: number[]
  }[]
  isComplete: boolean
  isValid: boolean
}

type QuickPickConfig = {
  selectableMax: number
  selectableNumbers: number[]
}

export const quickPickPlay = (
  { fields, isComplete, isValid }: Play,
  { selectableMax, selectableNumbers }: QuickPickConfig,
  fieldIndex: number,
  clearIfComplete = true,
) => {
  const numbers = new Set(fields[fieldIndex]?.selected)

  if (clearIfComplete) {
    const areAllFieldsComplete = fields.every(({ selected }) => selected.length === selectableMax)
    if (isComplete || (!isValid && areAllFieldsComplete)) numbers.clear()
  }

  return quickPickNumbers({ selectableMax, selectableNumbers }, numbers)
}

export const quickPickNumbers = (
  { selectableMax, selectableNumbers }: QuickPickConfig,
  numbers: Set<number> = new Set(),
) => {
  const available = selectableNumbers.filter((number) => !numbers.has(number))
  while (numbers.size < selectableMax && available.length) {
    const index = getRandomNumber(0, available.length - 1)
    numbers.add(available[index])
    available.splice(index, 1)
  }

  return [...numbers].sort((a, b) => selectableNumbers.indexOf(a) - selectableNumbers.indexOf(b))
}
